export const sampleData = {
    "Chemia": {
        "Attendances": {
            "Details": {
                "1": {
                    "21": {
                        "date": "2023-09-08",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "22": {
                        "date": "2023-09-08",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "53": {
                        "date": "2023-09-15",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "54": {
                        "date": "2023-09-15",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "83": {
                        "date": "2023-09-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "84": {
                        "date": "2023-09-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "115": {
                        "date": "2023-09-29",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "116": {
                        "date": "2023-09-29",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "156": {
                        "date": "2023-10-06",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "157": {
                        "date": "2023-10-06",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "196": {
                        "date": "2023-10-13",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "197": {
                        "date": "2023-10-13",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "269": {
                        "date": "2023-10-27",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "270": {
                        "date": "2023-10-27",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "292": {
                        "date": "2023-11-03",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "293": {
                        "date": "2023-11-03",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "325": {
                        "date": "2023-11-10",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "326": {
                        "date": "2023-11-10",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "353": {
                        "date": "2023-11-17",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "354": {
                        "date": "2023-11-17",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "394": {
                        "date": "2023-11-24",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "395": {
                        "date": "2023-11-24",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "425": {
                        "date": "2023-12-01",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "426": {
                        "date": "2023-12-01",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "488": {
                        "date": "2023-12-15",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "489": {
                        "date": "2023-12-15",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "553": {
                        "date": "2024-01-05",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "554": {
                        "date": "2024-01-05",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "586": {
                        "date": "2024-01-12",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "587": {
                        "date": "2024-01-12",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    }
                },
                "2": {
                    "616": {
                        "date": "2024-01-19",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "618": {
                        "date": "2024-01-19",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "650": {
                        "date": "2024-01-26",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "651": {
                        "date": "2024-01-26",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "690": {
                        "date": "2024-02-16",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "691": {
                        "date": "2024-02-16",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "728": {
                        "date": "2024-02-23",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "729": {
                        "date": "2024-02-23",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "760": {
                        "date": "2024-03-01",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "761": {
                        "date": "2024-03-01",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "802": {
                        "date": "2024-03-08",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "803": {
                        "date": "2024-03-08",
                        "semester": 2,
                        "type": "Obecność"
                    }
                }
            },
            "Summary": {
                "1": {
                    "Quantity": 30,
                    "Obecność": 22,
                    "Nieobecność usprawiedliwiona": 8
                },
                "2": {
                    "Quantity": 12,
                    "Obecność": 12
                }
            }
        },
        "Grades": {
            "1": [
                {
                    "Name": "Chemia",
                    "Grade": "1",
                    "Date": "2023-09-22",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "kartkówka",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Tlenki, Wodorki, Wodorotlenki"
                },
                {
                    "Name": "Chemia",
                    "Grade": "5",
                    "Date": "2023-10-06",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "aktywność",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Chemia",
                    "Grade": "5",
                    "Date": "2023-10-27",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "kartkówka",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Sole, Kwasy"
                },
                {
                    "Name": "Chemia",
                    "Grade": "3",
                    "Date": "2023-11-07",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "kartkówka",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Chemia",
                    "Grade": "5",
                    "Date": "2024-01-05",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "projekt",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Chemia",
                    "Grade": "4",
                    "Date": "2024-01-05",
                    "Semester": 1,
                    "IsConstituent": false,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": true,
                    "IsSemesterProposition": false,
                    "CategoryName": "śródroczna",
                    "GradeCountToTheAverage": false,
                    "GradeComment": "Brak"
                }
            ],
            "2": [
                {
                    "Name": "Chemia",
                    "Grade": "2",
                    "Date": "2024-01-19",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Kartkówka",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "Mol/masa cząsteczkowa"
                },
                {
                    "Name": "Chemia",
                    "Grade": "3",
                    "Date": "2024-01-19",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Kartkówka",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "Organiczna"
                },
                {
                    "Name": "Chemia",
                    "Grade": "2",
                    "Date": "2024-01-26",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Sprawdzian",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 3,
                    "GradeComment": "Stechiometria"
                }
            ]
        },
        "Days": [
            5,
            5
        ],
        "Properties": {
            "ShortName": "che"
        }
    },
    "Godzina wychowawcza": {
        "Attendances": {
            "Details": {
                "1": {
                    "15": {
                        "date": "2023-09-06",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "50": {
                        "date": "2023-09-13",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "109": {
                        "date": "2023-09-27",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "148": {
                        "date": "2023-10-04",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "190": {
                        "date": "2023-10-11",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "231": {
                        "date": "2023-10-18",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "261": {
                        "date": "2023-10-25",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "319": {
                        "date": "2023-11-08",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "384": {
                        "date": "2023-11-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "420": {
                        "date": "2023-11-29",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "520": {
                        "date": "2023-12-20",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "547": {
                        "date": "2024-01-03",
                        "semester": 1,
                        "type": "Obecność"
                    }
                },
                "2": {
                    "609": {
                        "date": "2024-01-17",
                        "semester": 2,
                        "type": "Zwolnienie"
                    },
                    "643": {
                        "date": "2024-01-24",
                        "semester": 2,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "684": {
                        "date": "2024-02-14",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "721": {
                        "date": "2024-02-21",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "753": {
                        "date": "2024-02-28",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "794": {
                        "date": "2024-03-06",
                        "semester": 2,
                        "type": "Nieobecność usprawiedliwiona"
                    }
                }
            },
            "Summary": {
                "1": {
                    "Quantity": 12,
                    "Obecność": 9,
                    "Nieobecność usprawiedliwiona": 3
                },
                "2": {
                    "Quantity": 6,
                    "Zwolnienie": 1,
                    "Nieobecność usprawiedliwiona": 2,
                    "Obecność": 3
                }
            }
        },
        "Grades": {},
        "Days": [
            3
        ],
        "Properties": {
            "ShortName": "gw"
        }
    },
    "Język angielski": {
        "Attendances": {
            "Details": {
                "1": {
                    "10": {
                        "date": "2023-09-06",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "17": {
                        "date": "2023-09-07",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "18": {
                        "date": "2023-09-07",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "23": {
                        "date": "2023-09-08",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "24": {
                        "date": "2023-09-08",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "75": {
                        "date": "2023-09-20",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "79": {
                        "date": "2023-09-21",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "80": {
                        "date": "2023-09-21",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "85": {
                        "date": "2023-09-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "86": {
                        "date": "2023-09-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "104": {
                        "date": "2023-09-27",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "111": {
                        "date": "2023-09-28",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "112": {
                        "date": "2023-09-28",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "117": {
                        "date": "2023-09-29",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "118": {
                        "date": "2023-09-29",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "143": {
                        "date": "2023-10-04",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "151": {
                        "date": "2023-10-05",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "152": {
                        "date": "2023-10-05",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "158": {
                        "date": "2023-10-06",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "159": {
                        "date": "2023-10-06",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "185": {
                        "date": "2023-10-11",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "192": {
                        "date": "2023-10-12",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "193": {
                        "date": "2023-10-12",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "198": {
                        "date": "2023-10-13",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "199": {
                        "date": "2023-10-13",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "226": {
                        "date": "2023-10-18",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "233": {
                        "date": "2023-10-19",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "234": {
                        "date": "2023-10-19",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "236": {
                        "date": "2023-10-20",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "237": {
                        "date": "2023-10-20",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "258": {
                        "date": "2023-10-25",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "265": {
                        "date": "2023-10-26",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "266": {
                        "date": "2023-10-26",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "271": {
                        "date": "2023-10-27",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "272": {
                        "date": "2023-10-27",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "294": {
                        "date": "2023-11-03",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "295": {
                        "date": "2023-11-03",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "314": {
                        "date": "2023-11-08",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "321": {
                        "date": "2023-11-09",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "322": {
                        "date": "2023-11-09",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "327": {
                        "date": "2023-11-10",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "328": {
                        "date": "2023-11-10",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "345": {
                        "date": "2023-11-15",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "350": {
                        "date": "2023-11-16",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "351": {
                        "date": "2023-11-16",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "355": {
                        "date": "2023-11-17",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "356": {
                        "date": "2023-11-17",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "378": {
                        "date": "2023-11-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "388": {
                        "date": "2023-11-23",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "389": {
                        "date": "2023-11-23",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "396": {
                        "date": "2023-11-24",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "397": {
                        "date": "2023-11-24",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "415": {
                        "date": "2023-11-29",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "422": {
                        "date": "2023-11-30",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "423": {
                        "date": "2023-11-30",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "427": {
                        "date": "2023-12-01",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "428": {
                        "date": "2023-12-01",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "453": {
                        "date": "2023-12-07",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "455": {
                        "date": "2023-12-07",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "460": {
                        "date": "2023-12-08",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "461": {
                        "date": "2023-12-08",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "478": {
                        "date": "2023-12-13",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "485": {
                        "date": "2023-12-14",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "486": {
                        "date": "2023-12-14",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "490": {
                        "date": "2023-12-15",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "492": {
                        "date": "2023-12-15",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "514": {
                        "date": "2023-12-20",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "522": {
                        "date": "2023-12-21",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "523": {
                        "date": "2023-12-21",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "528": {
                        "date": "2023-12-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "529": {
                        "date": "2023-12-22",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "541": {
                        "date": "2024-01-03",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "549": {
                        "date": "2024-01-04",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "550": {
                        "date": "2024-01-04",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "555": {
                        "date": "2024-01-05",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "556": {
                        "date": "2024-01-05",
                        "semester": 1,
                        "type": "Obecność"
                    },
                    "576": {
                        "date": "2024-01-11",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "577": {
                        "date": "2024-01-11",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "588": {
                        "date": "2024-01-12",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "589": {
                        "date": "2024-01-12",
                        "semester": 1,
                        "type": "Nieobecność usprawiedliwiona"
                    }
                },
                "2": {
                    "608": {
                        "date": "2024-01-17",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "612": {
                        "date": "2024-01-18",
                        "semester": 2,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "613": {
                        "date": "2024-01-18",
                        "semester": 2,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "619": {
                        "date": "2024-01-19",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "638": {
                        "date": "2024-01-24",
                        "semester": 2,
                        "type": "Nieobecność usprawiedliwiona"
                    },
                    "646": {
                        "date": "2024-01-25",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "647": {
                        "date": "2024-01-25",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "652": {
                        "date": "2024-01-26",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "653": {
                        "date": "2024-01-26",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "678": {
                        "date": "2024-02-14",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "687": {
                        "date": "2024-02-15",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "688": {
                        "date": "2024-02-15",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "692": {
                        "date": "2024-02-16",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "693": {
                        "date": "2024-02-16",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "714": {
                        "date": "2024-02-21",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "723": {
                        "date": "2024-02-22",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "725": {
                        "date": "2024-02-22",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "730": {
                        "date": "2024-02-23",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "731": {
                        "date": "2024-02-23",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "748": {
                        "date": "2024-02-28",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "755": {
                        "date": "2024-02-29",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "757": {
                        "date": "2024-02-29",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "762": {
                        "date": "2024-03-01",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "763": {
                        "date": "2024-03-01",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "788": {
                        "date": "2024-03-06",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "797": {
                        "date": "2024-03-07",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "798": {
                        "date": "2024-03-07",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "804": {
                        "date": "2024-03-08",
                        "semester": 2,
                        "type": "Obecność"
                    },
                    "805": {
                        "date": "2024-03-08",
                        "semester": 2,
                        "type": "Obecność"
                    }
                }
            },
            "Summary": {
                "1": {
                    "Quantity": 80,
                    "Obecność": 64,
                    "Nieobecność usprawiedliwiona": 16
                },
                "2": {
                    "Quantity": 29,
                    "Obecność": 26,
                    "Nieobecność usprawiedliwiona": 3
                }
            }
        },
        "Grades": {
            "1": [
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2023-09-22",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "aktywność",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "E mail"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2023-10-08",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Sprawdzian 2",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2023-10-26",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "aktywność",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2023-11-02",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Sprawdzian 2",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "wypracowanie"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "6",
                    "Date": "2023-11-22",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "zadanie",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2023-11-23",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "aktywność",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5-",
                    "Date": "2023-12-02",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Sprawdzian 2",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2023-12-12",
                    "Semester": 1,
                    "IsConstituent": false,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": true,
                    "CategoryName": "przewidywana śródroczna",
                    "GradeCountToTheAverage": false,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5-",
                    "Date": "2023-12-15",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Odpowiedź ustna-matura",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 3,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2024-01-05",
                    "Semester": 1,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "aktywność",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2024-01-09",
                    "Semester": 1,
                    "IsConstituent": false,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": true,
                    "IsSemesterProposition": false,
                    "CategoryName": "śródroczna",
                    "GradeCountToTheAverage": false,
                    "GradeComment": "Brak"
                }
            ],
            "2": [
                {
                    "Name": "Język angielski",
                    "Grade": "4",
                    "Date": "2024-01-18",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Sprawdzian 2",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2024-02-15",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "aktywność",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "4",
                    "Date": "2024-02-26",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "Sprawdzian 2",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 2,
                    "GradeComment": "Brak"
                },
                {
                    "Name": "Język angielski",
                    "Grade": "5",
                    "Date": "2024-02-29",
                    "Semester": 2,
                    "IsConstituent": true,
                    "IsFinal": false,
                    "IsFinalProposition": false,
                    "IsSemester": false,
                    "IsSemesterProposition": false,
                    "CategoryName": "zadanie",
                    "GradeCountToTheAverage": true,
                    "GradeWeight": 1,
                    "GradeComment": "Brak"
                }
            ]
        },
        "Days": [
            4,
            3,
            4,
            5,
            5
        ],
        "Properties": {
            "ShortName": "jang"
        }
    },
    "Biologia": {
        "Attendances": {},
        "Grades": {},
        "Days": {},
        "Properties": {
            "ShortName": "bio"
        }
    },
    "Ukryty przedmiot 1": {
        "Attendances": {},
        "Grades": {},
        "Days": {},
        "Properties": {
            "ShortName": "bio"
        }
    },
    "Ukryty przedmiot 2": {
        "Attendances": {},
        "Grades": {},
        "Days": {},
        "Properties": {
            "ShortName": "bio"
        }
    },
    "Ukryty przedmiot 3": {
        "Attendances": {},
        "Grades": {},
        "Days": {},
        "Properties": {
            "ShortName": "bio"
        }
    }
}